import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServisesRoutingModule } from './servises-routing.module';
import { ServisesComponent } from './servises.component';
import { NgxTypedJsModule } from 'ngx-typed-js';


@NgModule({
  declarations: [ServisesComponent],
  imports: [
    CommonModule,
    ServisesRoutingModule,
    NgxTypedJsModule
  ]
})
export class ServisesModule { }
